/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action, computed } from '@ember/object';
import { inject as service } from '@ember/service';
import BaseEditorComponent from 'cio/components/condition-list/edit/base';
import serialize from 'cio/utils/conditions/serialize/event';
import { elementContainsTarget } from 'cio/utils/dom';
import { isEventTargetInWormhole } from 'cio/utils/wormhole';
import isDestroyed from 'cio/utils/is-destroyed';

export default class ConditionListEditEventComponent extends BaseEditorComponent {
  @service environment;

  // external API
  variation = null;
  disabled = false;

  condition = null;
  campaign = null;
  allowBlankName = true;
  allowForeignEvent = false;
  disableForeignEvent = false;
  allowJsonOperators = false;
  hiddenEventInverseOptions = [];
  onApply() {}

  // internal API
  _clickStartedWithin = false;

  didInsertElement() {
    super.didInsertElement(...arguments);

    this._addHandlers();
  }

  willDestroyElement() {
    super.willDestroyElement(...arguments);
    this._removeHandlers();
  }

  _addHandlers() {
    this.element.addEventListener('mousedown', this._onMouseDown);
  }

  _removeHandlers() {
    this.element.removeEventListener('mousedown', this._onMouseDown);
  }

  @action
  _onMouseDown() {
    if (!isDestroyed(this)) {
      this.set('_clickStartedWithin', true);
    }
  }

  onOutsideClick(event) {
    // When opening fly-power-select, it animates the menu list as it appears.
    // When we click the trigger close to the bottom, that click's mouseup will
    // register on the menu list that's still being animated, making the whole
    // click register at the app's root. This would count as an outside click,
    // so we need to prevent that.
    // This may be related to https://github.com/cibernox/ember-power-select/issues/1263
    if (this._clickStartedWithin) {
      this.set('_clickStartedWithin', false);
      return;
    }

    if (!isDestroyed(this)) {
      this.set('_clickStartedWithin', false);
      let rootElement = this.element;
      let isComponent = rootElement === event.target;
      let inComponent = elementContainsTarget(rootElement, event.target);

      let inWormhole = isEventTargetInWormhole(event);

      if (isComponent || inComponent || inWormhole) {
        return;
      }

      this._onApply();
    }
  }

  @computed('condition.name')
  get errors() {
    let errors = [];

    if (!this.condition.name) {
      errors.push("Event name can't be blank.");
    }

    return errors;
  }

  @action
  _onApply() {
    let condition = serialize(this.condition);
    // The backend expects this to say "message" and not "event", since it will
    // use this to expand into the same bitmaps it uses for the "message" types.
    condition.type = 'message';

    if (this.condition.isForeignEvent) {
      condition.type = 'foreign_event';
    }

    return this.onApply(condition);
  }
}
